import { useEffect, useRef } from 'react';
import NoSleep from 'nosleep.js';
import { useAppStore } from '../store/appStore';

let globalNoSleep: NoSleep | null = null;

function getNoSleep(): NoSleep {
  if (!globalNoSleep) globalNoSleep = new NoSleep();
  return globalNoSleep;
}

export function useNoSleep() {
  const keepScreenOn = useAppStore((s) => s.settings.keep_screen_on);
  const initialized = useRef(false);

  useEffect(() => {
    const ns = getNoSleep();
    initialized.current = true;

    if (keepScreenOn) {
      ns.enable().catch(() => {});
    } else {
      ns.disable();
    }

    return () => {
      ns.disable();
    };
  }, [keepScreenOn]);
}

/**
 * Re-apply NoSleep based on current store setting.
 * Legacy calls updateScreenOn on every verse load to keep the wake lock active.
 */
export function reapplyNoSleep(): void {
  const keepScreenOn = useAppStore.getState().settings.keep_screen_on;
  const ns = getNoSleep();
  if (keepScreenOn) {
    ns.enable().catch(() => {});
  } else {
    ns.disable();
  }
}
